import { SIDEBAR_COMMON_STYLE } from "../../siteInfo/SiteStyle";
const recommendedPostsStyle = {
  recommendedPostsContainer: {
    width: "90%",
    maxWidth: 375,
    marginRight: "auto",
    marginLeft: "auto",
    marginBottom: 18,
    background: "white",
    borderRadius: 3,
    overflow: "hidden",
  },
  recommendedPostsHeader: {
    color: SIDEBAR_COMMON_STYLE.color,
    fontSize: SIDEBAR_COMMON_STYLE.headerFontSize,
    backgroundColor: SIDEBAR_COMMON_STYLE.mainColor,
    paddingTop: 9,
    paddingBottom: 9,
    textAlign: "center",
  },
  recommendedPostsList: {
    width: "100%",
    height: "fit-content",
    maxHeight: 450,
    overflow: "scroll",
    padding: 0,
  },
  listItem: {
    padding: 9,
  },
  postImg: {
    width: "100%",
    transition: "all .5s ease",
    borderRadius: 3,
    "&:hover": {
      boxShadow: "0 9px 9px 0px rgba(0, 0, 0, 0.6)",
      transform: "scale(1.03, 1.03)",
    },
  },
  link: {},
};
export default recommendedPostsStyle;
